import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPlanReviewJobSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type GetPlanReviewJobSubscription = { __typename?: 'subscription_root', plan_review_jobs_by_pk?: { __typename?: 'plan_review_jobs', id: any, plan_review_id: any, state: string, compliance_score?: number | null, review_outcome?: string | null, summary?: string | null, submission_number: number, property_context?: any | null, report_json?: any | null, error_message?: string | null, error_step?: string | null, analysis_started_at?: any | null, analysis_completed_at?: any | null, created_at: any, updated_at: any, plan_review: { __typename?: 'plan_reviews', id: any, ollie_id: string, property_id: any, organization_id?: any | null, workspace_id?: any | null, created_by_user_id?: string | null, review_type: string, jurisdiction_id?: any | null, property: { __typename?: 'properties', id: any, name: string, address?: string | null, photo_link?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string } | null }, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null, submission_type?: { __typename?: 'plan_review_submission_types', id: any, code: string, name: string, short_name?: string | null } | null, jurisdiction_record?: { __typename?: 'jurisdictions', id: any, name: string, short_name: string, state: string, county?: string | null, city?: string | null, ahj_type: string, primary_codes?: any | null, website_url?: string | null } | null, latest_submittal: Array<{ __typename?: 'plan_review_jobs', id: any }> }, ahj_submission_acknowledgments: Array<{ __typename?: 'plan_review_ahj_submission_acknowledgments', id: any }>, plan_review_documents: Array<{ __typename?: 'plan_review_documents', id: any, doc_type?: string | null, file_name: string, file_url: string, file_size_bytes?: any | null, mime_type: string, page_count?: number | null, review_status: string, created_at: any }> } | null };


export const GetPlanReviewJobDocument = gql`
    subscription getPlanReviewJob($id: uuid!) {
  plan_review_jobs_by_pk(id: $id) {
    id
    plan_review_id
    plan_review {
      id
      ollie_id
      property_id
      property {
        id
        name
        address
        standardized_address {
          id
          street_1
          street_2
          city
          state
          postal_code
        }
        photo_link
      }
      organization_id
      organization {
        id
        name
        type
        organizationImageURL
      }
      workspace_id
      created_by_user_id
      review_type
      submission_type {
        id
        code
        name
        short_name
      }
      jurisdiction_id
      jurisdiction_record {
        id
        name
        short_name
        state
        county
        city
        ahj_type
        primary_codes
        website_url
      }
      latest_submittal: plan_review_jobs(
        where: {state: {_neq: "FAILED"}}
        order_by: {submission_number: desc}
        limit: 1
      ) {
        id
      }
    }
    state
    compliance_score
    review_outcome
    summary
    submission_number
    property_context
    report_json
    error_message
    error_step
    analysis_started_at
    analysis_completed_at
    created_at
    updated_at
    ahj_submission_acknowledgments {
      id
    }
    plan_review_documents(order_by: {created_at: asc}) {
      id
      doc_type
      file_name
      file_url
      file_size_bytes
      mime_type
      page_count
      review_status
      created_at
    }
  }
}
    `;

/**
 * __useGetPlanReviewJobSubscription__
 *
 * To run a query within a React component, call `useGetPlanReviewJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanReviewJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanReviewJobSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlanReviewJobSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetPlanReviewJobSubscription, GetPlanReviewJobSubscriptionVariables> & ({ variables: GetPlanReviewJobSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetPlanReviewJobSubscription, GetPlanReviewJobSubscriptionVariables>(GetPlanReviewJobDocument, options);
      }
export type GetPlanReviewJobSubscriptionHookResult = ReturnType<typeof useGetPlanReviewJobSubscription>;
export type GetPlanReviewJobSubscriptionResult = Apollo.SubscriptionResult<GetPlanReviewJobSubscription>;